import { Star } from 'lucide-react'
import { useIsMobile } from '@/hooks/useIsMobile'
import BottomSheet from '@/components/Common/BottomSheet'

// Extraído literalmente de ChartPage.jsx ("Favorites dropdown", antes inline
// en el toolbar) para que ChartPublicPage.jsx tenga el mismo acceso rápido a
// pares favoritos — no solo la ⭐ dentro del buscador (SymbolSelector), sino
// este botón dedicado con badge y lista de acceso directo. Puramente
// presentacional: recibe favorites/selectedSymbol/onSelect/onToggleFavorite,
// el propio show/hide y el ref de "clic fuera" los sigue manejando la página.
export default function FavoritesMenu({
  favorites,
  selectedSymbol,
  onSelect,
  onToggleFavorite,
  showMenu,
  onToggleMenu,
  menuRef,
  buttonClassName = '',
}) {
  const isMobile = useIsMobile()

  const list = (
    favorites.length === 0 ? (
      <p className="px-4 py-3 text-xs text-slate-400 dark:text-gray-600">Sin favoritos. Usa la ★ en el buscador.</p>
    ) : (
      favorites.map(sym => (
        <button
          key={sym}
          onClick={() => onSelect(sym)}
          className={`w-full flex items-center justify-between px-4 py-3 md:py-2 text-sm hover:bg-slate-50 dark:hover:bg-gray-700 ${sym === selectedSymbol ? 'bg-blue-50 dark:bg-blue-900/20 text-blue-600' : 'text-slate-700 dark:text-gray-300'}`}
        >
          <span className="font-medium">{sym.replace('/USDT:USDT', '').replace('/USDC:USDC', '')}</span>
          <button
            onClick={e => { e.stopPropagation(); onToggleFavorite(sym) }}
            className="p-1.5 md:p-0.5 text-amber-400 hover:text-slate-400 rounded"
          >
            <Star size={11} className="fill-amber-400" />
          </button>
        </button>
      ))
    )
  )

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={onToggleMenu}
        title="Pares favoritos"
        className={buttonClassName || `flex items-center gap-1 px-2.5 py-2.5 md:py-1.5 text-xs font-semibold rounded-lg border transition-colors ${
          showMenu || favorites.length > 0
            ? 'bg-amber-50 dark:bg-amber-900/20 border-amber-200 dark:border-amber-700 text-amber-600 dark:text-amber-400'
            : 'bg-white dark:bg-gray-800 border-slate-200 dark:border-gray-700 text-slate-600 dark:text-gray-300 hover:bg-slate-50 dark:hover:bg-gray-750'
        }`}
      >
        <Star size={13} className={favorites.length > 0 ? 'fill-amber-400 text-amber-400' : ''} />
        {favorites.length > 0 && <span>{favorites.length}</span>}
      </button>
      {showMenu && (isMobile ? (
        <BottomSheet title="Favoritos" onClose={onToggleMenu}>
          {list}
        </BottomSheet>
      ) : (
        <div className="absolute top-full right-0 mt-1 w-52 bg-white dark:bg-gray-800 border border-slate-200 dark:border-gray-700 rounded-xl shadow-xl z-50 overflow-hidden">
          {list}
        </div>
      ))}
    </div>
  )
}
